import { AtomBox, AtomBoxProps } from "@pancakeswap/ui";
import React from "react";

export type RowProps = AtomBoxProps &
  Omit<React.HTMLAttributes<HTMLDivElement>, "className" | "color"> & {
    children?: React.ReactNode;
  };

export const Row = ({
  width = "100%",
  alignItems = "center",
  justifyContent = "flex-start",
  padding = "0",
  children,
  ...props
}: RowProps) => (
  <AtomBox
    display="flex"
    width={width}
    alignItems={alignItems}
    justifyContent={justifyContent}
    padding={padding}
    {...props}
  >
    {children}
  </AtomBox>
);

export const AutoRow = (props: RowProps) => <Row flexWrap="wrap" {...props} />;

export const RowFixed = (props: RowProps) => <Row width="fit" flexWrap="wrap" {...props} />;

export const RowBetween = (props: RowProps) => <Row flexWrap="wrap" justifyContent="space-between" {...props} />;
